/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as driversSlice from './driversSlice';

export default function* watchDriversSaga() {
 yield takeLatest(driversSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(driversSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(driversSlice.createItemStart.type, commonSagas.createItem);
 yield takeLatest(driversSlice.updateItemStart.type, commonSagas.updateItem);
 yield takeLatest(driversSlice.deleteItemsStart.type, commonSagas.deleteItems);
 yield takeLatest(driversSlice.deleteItemStart.type, commonSagas.deleteItem);
 yield takeLatest(
  driversSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  driversSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  driversSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  driversSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(
  driversSlice.getTableExcelStart.type,
  commonSagas.getTableExcel,
 );
}
